export default __webpack_public_path__ + "static/mexinavi-banner-f6a54e73294a959d8bfd8d49555220a9.svg";